import { createContext, useState } from 'react';
import { useNavigate } from 'react-router';
import AuthService from '../services/auth-service';
import useIdMultiPrelievo from "../hooks/useIdMultiPrelievo.js";

const AuthContext = createContext('auth');

const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [token, setToken] = useState(AuthService.token);
    const [user, setUser] = useState(AuthService.user);
    const [error, setError] = useState(null);
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [,, resetIdMacroPrelievo] = useIdMultiPrelievo();

    const handleLogin = async event => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        setIsLoggingIn(true);
        try {
            await AuthService.login(data.get('username'), data.get('password'));
            setToken(AuthService.token);
            setUser(AuthService.user);
            setError(null);
            navigate('/');
        } catch (e) {
            setError(e);
            console.warn(e);
        }
        setIsLoggingIn(false);
    };

    const handleLogout = () => {
        AuthService.logout().then(() => {
            resetIdMacroPrelievo();
            setToken(null);
            setUser(null);
            navigate('/login');
        });
    };

    const object = {
        onLogin: handleLogin,
        onLogout: handleLogout,
        token,
        user,
        error,
        isLoggingIn
    };

    return <AuthContext.Provider value={object}>{children}</AuthContext.Provider>;
};

export { AuthProvider, AuthContext };
